export const notiKeys = {
  getAllNoti: (params: any) => ['getAllNoti', params],
};
